import { defineComponent } from "vue";

import DemographicsInformation from "./DemographicsInformation/DemographicsInformation.vue";
import FacesheetComments from "./FacesheetComments/FacesheetComments.vue";
import ServiceLocations from "./ServiceLocations/ServiceLocations.vue";

export default defineComponent({
    components: {
        DemographicsInformation,
        FacesheetComments,
        ServiceLocations
    }
});
